import PosCartActions from '../../../actions/PosCartActions';
import NotificationActions from '../../../actions/NotificationActions';

import UserStore from '../../../stores/UserStore';

class UpdateQuantity extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible  : false,
            qty      : '0',
            lastFour : '',
            lastFourRequired : UserStore.getState().selectedLocation.Last4
        };

        this.show = this.show.bind(this);
        this.updateQuantity = this.updateQuantity.bind(this);
    }

    componentWillUnmount() {
        $('.pos-sidebar').css({ 'z-index' : 2 });
    }

    componentDidUpdate() {
        $('.pos-sidebar').css({
            'z-index' : this.state.visible ? 1 : 2
        })
    }

    show() {
        this.setState({
            visible : true,
            qty     : this.props.item.QtyAllocated
        });
    }

    updateQuantity() {
        if (this.state.qty.length < 1)
            return;

        var item = this.props.item;

        if (this.state.lastFourRequired && this.state.lastFour !== item.SerialNo.substr(item.SerialNo.length - 4)) {
            NotificationActions.addNotification({
                type : 'alert',
                body : 'SerialNo is not matching'
            });
            return;
        }

        if (this.state.qty === item.QtyAllocated) {
            NotificationActions.addNotification({
                type : 'alert',
                body : 'Update quantity to continue'
            });
            return;
        }

        var qty = parseInt(this.state.qty);

        this.setState({ visible : false, lastFour : '' }, () => {
            // if (qty === 0) {
            //     PosCartActions.removeItemFromCart(item, this.props.guest, item.QtyAllocated, true);
            // } 
            
            if (qty > item.QtyAllocated) {
                if (!item.hasOwnProperty('UnitPrice')) {
                    item.UnitPrice = item.TotalCost / item.QtyAllocated;
                }
                item.PackageItemId = null;
                PosCartActions.addItemToCart(item, this.props.guest, qty - item.QtyAllocated);
            } else {
                PosCartActions.removeItemFromCart(item, this.props.guest, item.QtyAllocated - qty, true);
            }
        });
    }

    render() {
        var item        = this.props.item;
        var cart        = this.props.cart;
        var guest       = this.props.guest;

        if (guest.IsPaid)
            return null;

        return (
            <div>
                <div
                    className='cart-item__options--quantity btn-green'
                    onClick={this.show}>

                    UPDATE QTY
                </div>

                { this.state.visible &&
                    <div className='popup popup__transparent'>
                        <div className='popup__content increase__last-four'>
                            <div className='popup-header'>
                                UPDATE QUANTITY

                                <div
                                    className='popup-close'
                                    onClick={() => { this.setState({ visible : false }); }}>

                                    <i className='fa fa-times' aria-hidden='true' />
                                </div>
                            </div>

                            { this.state.lastFourRequired &&
                                <input
                                    type='text'
                                    id='last-four'
                                    value={this.state.lastFour}
                                    placeholder='Last four digits'
                                    onChange={(e) => { this.setState({ lastFour : e.target.value }); }} />
                            }

                            <input
                                type='text'
                                id='last-four'
                                value={this.state.qty}
                                placeholder='Quantity'
                                onChange={(e) => { this.setState({ qty : e.target.value.replace(/[^0-9]/g, '') }); }} />

                            <div
                                className='increase__last-four--go'
                                onClick={this.updateQuantity}>

                                OK
                            </div>


                        </div>

                    </div>
                }
            </div>
        );
    }
}

export default UpdateQuantity;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/selected/UpdateQuantity.react.jsx